import moment from 'moment';

class Customer {
    public typeId: number;
    public type?: string;
    public firstname: string;
    public surname: string;
    public stateOfBirthId: string;
    public stateOfBirth?: string;
    public cityOfBirthId?: number;
    public cityOfBirth?: string;
    public dateOfBirth?: moment.Moment;
    public fiscalId: string;
    public cityResidenceId?: number;
    public provinceResidenceId: string;
    public cityResidence?: string;
    public postalCodeResidence: string;
    public addressResidence: string;
    public citySocietyId?: number;
    public provinceSocietyId: string;
    public citySociety?: string;
    public postalCodeSociety: string;
    public addressSociety: string;
    public docTypeId?: number;
    public docType?: string;
    public docNumber: string;
    public releasedBy: string;
    public releasedOn?: moment.Moment;
    public isBusiness: number;
    public vatNumber: string;
    public businessName: string;
    public pec: string;
    public sdi: string;
    public tel1: string;
    public tel2: string;
    public email: string;

    constructor(
        typeId?: number,
        type?: string,
        firstname?: string,
        surname?: string,
        stateOfBirthId?: string,
        stateOfBirth?: string,
        cityOfBirthId?: number,
        cityOfBirth?: string,
        dateOfBirth?: moment.Moment,
        fiscalId?: string,
        cityResidenceId?: number,
        provinceResidenceId?: string,
        cityResidence?: string,
        postalCodeResidence?: string,
        addressResidence?: string,
        citySocietyId?: number,
        provinceSocietyId?: string,
        citySociety?: string,
        postalCodeSociety?: string,
        addressSociety?: string,
        docTypeId?: number,
        docType?: string,
        docNumber?: string,
        releasedBy?: string,
        releasedOn?: moment.Moment,
        isBusiness?: number,
        vatNumber?: string,
        businessName?: string,
        pec?: string,
        sdi?: string,
        tel1?: string,
        tel2?: string,
        email?: string
    ) {
        this.typeId = typeId || 0;
        this.type = type || undefined;
        this.firstname = firstname || '';
        this.surname = surname || '';
        this.stateOfBirthId = stateOfBirthId || 'IT';
        this.stateOfBirth = stateOfBirth || 'ITALIA';
        this.cityOfBirthId = cityOfBirthId || undefined;
        this.cityOfBirth = cityOfBirth || undefined;
        this.dateOfBirth = dateOfBirth || undefined;
        this.fiscalId = fiscalId || '';
        this.cityResidenceId = cityResidenceId || undefined;
        this.provinceResidenceId = provinceResidenceId || '';
        this.cityResidence = cityResidence || undefined;
        this.postalCodeResidence = postalCodeResidence || '';
        this.addressResidence = addressResidence || '';
        this.citySocietyId = cityResidenceId || undefined;
        this.provinceSocietyId = provinceResidenceId || '';
        this.citySociety = cityResidence || undefined;
        this.postalCodeSociety = postalCodeResidence || '';
        this.addressSociety = addressResidence || '';
        this.docTypeId = docTypeId || undefined;
        this.docType = docType || undefined;
        this.docNumber = docNumber || '';
        this.releasedBy = releasedBy || '';
        this.releasedOn = releasedOn || undefined;
        this.isBusiness = isBusiness === 1 ? 1 : 0;
        this.vatNumber = vatNumber || '';
        this.businessName = businessName || '';
        this.pec = pec || '';
        this.sdi = sdi || '';
        this.tel1 = tel1 || '';
        this.tel2 = tel2 || '';
        this.email = email || '';
    }
}

export default Customer;
